exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3a623{color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"progress-played": "_3a623",
	"progressPlayed": "_3a623"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/player-widget/components/new-player/components/progress-bar.styl
// module id = 1451
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact